var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormLegalDetail", {
                attrs: {
                  data: _vm.legalDetail,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                },
                on: {
                  submit: _vm.onFormSubmit,
                  "delete-detail": _vm.onDeleteDetail,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmDetailDelete",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }